import { Button } from '../ui/button';
import { Star, Trash2, ArrowRight } from 'lucide-react';

export function AdminReviewsTab({ reviews, onDeleteReview }) {
  return (
    <div className="card-surface overflow-hidden">
      {reviews.length === 0 ? (
        <p className="text-stone-400 text-center py-12">No reviews yet</p>
      ) : (
        <div className="divide-y divide-[#E6E4DD]">
          {reviews.map(r => {
            const isClientToProvider = r.review_type !== 'provider_to_client';
            return (
              <div key={r.review_id} className="p-4 hover:bg-[#F9F6F0] flex items-start gap-4" data-testid={`review-${r.review_id}`}>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="font-medium text-[#1A1A1A] text-sm">{isClientToProvider ? r.client_name : r.provider_name}</span>
                    <ArrowRight className="h-3 w-3 text-stone-400" />
                    <span className="font-medium text-[#1A1A1A] text-sm">{isClientToProvider ? r.provider_name : r.client_name}</span>
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${isClientToProvider ? 'bg-blue-50 text-blue-600' : 'bg-purple-50 text-purple-600'}`}>
                      {isClientToProvider ? 'Client → Provider' : 'Provider → Client'}
                    </span>
                  </div>
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, starIdx) => (
                      <Star key={`star-${starIdx}`} className={`h-3.5 w-3.5 ${starIdx < r.rating ? 'text-[#D4AF37] fill-current' : 'text-stone-200'}`} />
                    ))}
                    <span className="text-xs text-stone-400 ml-1">{r.created_at ? new Date(r.created_at).toLocaleDateString('en-GB') : ''}</span>
                  </div>
                  {r.text && <p className="text-sm text-stone-600 line-clamp-2">{r.text}</p>}
                  {r.provider_response && (
                    <div className="mt-2 pl-3 border-l-2 border-[#D4AF37]">
                      <p className="text-xs text-stone-400">Provider response:</p>
                      <p className="text-sm text-stone-600">{typeof r.provider_response === 'object' ? r.provider_response.text : r.provider_response}</p>
                    </div>
                  )}
                </div>
                <Button size="sm" variant="ghost" className="text-red-400 hover:text-red-600 h-8 px-2 flex-shrink-0" onClick={() => onDeleteReview(r.review_id)} data-testid={`delete-review-${r.review_id}`}>
                  <Trash2 className="h-3.5 w-3.5" />
                </Button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
